import { Briefcase, LineChart, Building2 } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

const ICONS = [Briefcase, LineChart, Building2];

export const ForWhom = () => {
  const { t } = useT();
  return (
    <section data-testid="for-whom-section" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <span className="al-tag">{t.forwhom.tag}</span>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight">
            {t.forwhom.h2a}<span className="al-grad-text">{t.forwhom.h2b}</span>{t.forwhom.h2c}
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {t.forwhom.personas.map((p, i) => {
            const Icon = ICONS[i] || Briefcase;
            return (
              <div key={p.title} data-testid={`persona-card-${i}`} className="al-card p-8">
                <div className="h-14 w-14 rounded-2xl al-grad-bg flex items-center justify-center text-white shadow-xl shadow-purple-500/25">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="mt-6 font-display font-semibold text-2xl">{p.title}</h3>
                <p className="mt-3 text-slate-600 leading-relaxed">{p.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
